import { render } from "./HistoryChat.vue?vue&type=template&id=4aa42305&scoped=true"
import script from "./HistoryChat.vue?vue&type=script&lang=js"
export * from "./HistoryChat.vue?vue&type=script&lang=js"

import "./HistoryChat.vue?vue&type=style&index=0&id=4aa42305&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aa42305"]])

export default __exports__